export default "__VITE_ASSET__cwQZfG0F__"